import React from "react";
import { Link } from "react-router-dom";
import paths from "../../routes/paths";
import {
  titleCodes,
  textCodes,
} from "../../template_codes/ncici/footer_page_codes";

function Footer() {
  return (
    <div className="container w-5/6 ">
      <footer class="footer p-10">
        <div>
          <p className="font-semibold text-xl">
            {titleCodes.AddressTitle.title}
          </p>
          <p>{textCodes.Address.text}</p>
        </div>
        <div>
          <p className="font-semibold text-xl">Phone No.</p>
          <p className="font-semibold">09757328335</p>
          <p className="font-semibold">09777781277</p>
        </div>
        <div>
          <div className="flex">
            <div>
              <a href="https://www.facebook.com/profile.php?id=100077924301446">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="2.5em"
                  height="2.5em"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95z"
                  />
                </svg>
              </a>
            </div>
            <div className="pl-4">
              <a href="#">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="2.5em"
                  height="2.5em"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M15.85 8.14c.39 0 .77.03 1.14.08C16.31 5.25 13.19 3 9.44 3c-4.25 0-7.7 2.88-7.7 6.43c0 2.05 1.15 3.86 2.94 5.04L3.67 16.5l2.76-1.19c.59.21 1.21.38 1.87.47c-.09-.39-.14-.79-.14-1.21c-.01-3.54 3.44-6.43 7.69-6.43zM12 5.89a.96.96 0 1 1 0 1.92a.96.96 0 0 1 0-1.92zM6.87 7.82a.96.96 0 1 1 0-1.92a.96.96 0 0 1 0 1.92z"
                  />
                  <path
                    fill="currentColor"
                    d="M22.26 14.57c0-2.84-2.87-5.14-6.41-5.14s-6.41 2.3-6.41 5.14s2.87 5.14 6.41 5.14c.58 0 1.14-.08 1.67-.2L20.98 21l-1.2-2.4c1.5-.94 2.48-2.38 2.48-4.03zm-8.34-.32a.96.96 0 1 1 .96-.96c.01.53-.43.96-.96.96zm3.85 0a.96.96 0 1 1 0-1.92a.96.96 0 0 1 0 1.92z"
                  />
                </svg>
              </a>
            </div>
          </div>
          <div>
            <p>
              Copyright © {new Date().getFullYear()}
              {textCodes.copyText.text}{" "}
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
